import React, { createContext, useState, useEffect, useContext } from 'react';
import { LOGGED_OUT_EVENT } from '../components/api.js';
const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [token, setToken] = useState(null);
  useEffect(() => {
    const storedToken = localStorage.getItem('token');
    if (storedToken) {
      setIsLoggedIn(true);
      setToken(storedToken);
    }
  }, []);

  useEffect(() => {
    window.addEventListener(LOGGED_OUT_EVENT, updateLoggedInStatus);
    return () => {
      window.removeEventListener(LOGGED_OUT_EVENT, updateLoggedInStatus);
    };
  }, []);

  // Функция для обновления состояния isLoggedIn на основе наличия или отсутствия токена в локальном хранилище
  const updateLoggedInStatus = () => {
    const storedToken = localStorage.getItem('token');
    setIsLoggedIn(!!storedToken); // Устанавливаем true, если есть токен, и false, если нет
    setToken(storedToken);
  };

  return (
    <AuthContext.Provider value={{ isLoggedIn, token, setIsLoggedIn, updateLoggedInStatus }}>
      {children}
    </AuthContext.Provider>
  );
};

export { AuthContext, AuthProvider };
